import { RouteObject } from 'react-router-dom';
import { NotificationLanding } from './components/Landing';

export interface notificationRoute extends Omit<RouteObject, 'children'> {
 auth?: boolean;
 children?: notificationRoute[];
}

export const notificationRoutes: notificationRoute[] = [
 {
   path: '/notification',
   element: <NotificationLanding />,
 },
];
